import { projectTemplateSlice } from './slices';

export const {
  fetchProjectTemplateStart,
  fetchProjectTemplateStartSuccess,
  createProjectTemplate,
  toggleProjectToTemplate,
  updateProjectTemplate,
  updateSpacesList,
  updateSpaceListOrder,
  updateSpaceOrder,
  clearProjectTemplate,
  updateProjectTemplateParentOfTask,
  setProjectTemplateActiveRecord,
  clearProjectTemplateActiveRecord,
  changeTemplateSaveState,
  deleteProjectTemplateSpaceTab,
  setupActiveSpace,
  setupActiveSpaceTab,
  saveTemplatePlaceholder,
  setProjectTemplateRecordForShowingVariablesSelect,
  clearProjectTemplateRecordForShowingVariablesSelect,
} = projectTemplateSlice.actions;

export * from './hooks';

export * from './api';
export * from './types';
